import API from "@/services/api";
import { 
  Tipus,
  Subtipus
} from "../types/reclamATC";

export enum EndpointName {
  FetchTipus = '/atc/tipus',
  FetchSubtipus = '/atc/tipus/:tipus/subtipus',
  // SetNoSIPSCession = '/contracts/:contractName/no_cession_sips/',
}

const fetchATCTipus = () => {
  return API.get<Tipus[]>({
    endpoint: EndpointName.FetchTipus,
  });
}

const fetchATCSubtipus = (tipus: Tipus) => {
  return API.get<Subtipus[]>({
    endpoint: EndpointName.FetchSubtipus,
    params: {
      tipus
    }
  });
}

// const sendSIPSCessionChange = ({
//   contractName,
//   newNoSIPSCessionSelection,
// }: ISendNoSIPSCessionChangeParams) => {
//   return API.post<INoCessionSIPSSucessResponse, INoCessionSIPSSetData>({
//     endpoint: EndpointName.SetNoSIPSCession,
//     data: {noCessionSelection: newNoSIPSCessionSelection},
//     params: {
//       contractName
//     }
//   });
// }

export default {
  fetchATCTipus,
  fetchATCSubtipus
};